<template>
  <v-app>
    <main-header />
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step
          :complete="e1 > 1"
          editable
          step="1">
          RAC Numbers
        </v-stepper-step>

        <v-divider />

        <v-stepper-step
          :complete="e1 > 2"
          editable
          step="2">
          RAC Validation
        </v-stepper-step>

        <v-divider />

        <v-stepper-step
          :complete="e1 > 3"
          editable
          step="3">
          Flights
        </v-stepper-step>

        <v-divider />

        <v-stepper-step
          :complete="e1 > 4"
          editable
          step="4">
          Drivers
        </v-stepper-step>

        <v-divider />

        <v-stepper-step
          :complete="e1 > 5"
          editable
          step="5">
          Identity Check
        </v-stepper-step>

        <v-divider />

        <v-stepper-step
          editable
          step="6">
          Manifests
        </v-stepper-step>

      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card
            class="mb-12"
            color="grey lighten-1"
            height="100%" />
          <daily-cargo-rac-number />
          <v-btn
            color="primary"
            style="float: right"
            @click="e1 = 2">
            Continue
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card
            class="mb-12"
            color="grey lighten-1"
            height="100%" />
          <daily-cargo-rac-validation />
          <v-btn
            color="primary"
            style="float: right"
            @click="e1 = 3">
            Continue
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card
            class="mb-12"
            color="grey lighten-1"
            height="100%" />
          <daily-cargo-flight-administration />
          <v-btn
            color="primary"
            style="float: right"
            @click="e1 = 4">
            Continue
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-card
            class="mb-12"
            color="grey lighten-1"
            height="100%" />
          <daily-cargo-driver-administration />
          <v-btn
            color="primary"
            style="float: right"
            @click="e1 = 5">
            Continue
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="5">
          <v-card
            class="mb-12"
            color="grey lighten-1"
            height="100%" />
          <daily-cargo-identity-check-sheet />
          <v-btn
            color="primary"
            style="float: right"
            @click="e1 = 6">
            Continue
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="6">
          <v-card
            class="mb-12"
            color="grey lighten-1"
            height="100%" />
          <daily-cargo-list />
          <v-btn
            color="primary"
            style="float: right"
            @click="e1 = 1">
            Continue
          </v-btn>

        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-app>
</template>
<script>
export default {
  data () {
    return {
      e1: 1
    }
  },
  created () {
    if (this.$route.params.id) {
      this.e1 = this.$route.params.id
    }
  }
}
</script>
<style lang="scss">
  .v-application .mb-12 {
     margin-bottom: 0px !important;
  }
  .v-stepper__content {
    padding: 24px 0px 0px 24px !important;
  }
</style>
